class Wishlist {
  constructor() {
    this.isWishlistPage = false;
    this.storageKey = "m-wishlist-products";
    this.products = [];
    this.productNodes = {};
    this.pageTemplate = "page.wishlist";
    this.addedClass = "added-to-wishlist";
    this.hasItemClass = "wishlist-has-item";
    this.selectors = {
      content: ".m-wishlist-page-content",
      container: ".m-wishlist-page-content__wrapper",
      noProducts: ".m-wishlist-no-products",
      wrapper: ".m-wishlist-card",
      productCard: ".m-product-card",
      wishlistButton: ".m-wishlist-button",
      wishlistText: ".m-wishlist-button-text",
      tooltipContent: "[data-tippy-content]",
      removeButton: ".m-wishlist-remove-button",
      count: ".m-wishlist-count",
      pagination: ".m-pagination",
      paginationPrev: ".m-pagination-prev",
      paginationNext: ".m-pagination-next",
      paginationNumbers: ".m-pagination-numbers",
    };
    this.currentPage = 1;
    this.productsPerPage = 12;
    this.products = Array.from(new Set(Array.from(JSON.parse(localStorage.getItem(this.storageKey)) || [])));
    this.isWishlistPage = MinimogSettings.template === this.pageTemplate;
    this.init();
  }

  init = async () => {
    if (this.isWishlistPage) {
      await this.renderWishlistPage();
      this.addEventToRemoveButtons();
      this.addEventToPaginationButtons();
    }
    this.setWishlistButtonsState();
    this.addEventToWishlistButtons();
    this.updateWishlistCount();
  };

  saveToStorage = () => {
    this.products = Array.from(new Set(this.products));
    localStorage.setItem(this.storageKey, JSON.stringify(this.products));
  };

  addToWishlist(t) {
    if (t && this.products.indexOf(t) === -1) {
      this.products.push(t);
      this.saveToStorage();
    }
  }

  removeFromWishlist(t) {
    this.products = this.products.filter(s => s !== t);
    this.saveToStorage();
  }

  setWishlistButtonsState = () => {
    document.querySelectorAll(this.selectors.wishlistButton).forEach(t => {
      const s = t && t.dataset.productHandle;
      if (this.products.indexOf(s) >= 0 && t && !t.classList.contains(this.addedClass)) {
        this.toggleButtonState(t, true);
        if (this.isWishlistPage) {
          t.classList.remove(this.selectors.wishlistButton.replace(".", ""));
          t.classList.add(this.selectors.removeButton.replace(".", ""));
        }
      }
    });
  };

  updateWishlistCount = () => {
    const t = this.products.length;
    [...document.querySelectorAll(this.selectors.count)].forEach(s => {
      s.textContent = t;
      if (t < 1) {
        s.classList.add("m:hidden");
      } else {
        s.classList.remove("m:hidden");
      }
    });
    const s = t ? "add" : "remove";
    document.body.classList[s](this.hasItemClass);
  };

  addEventToWishlistButtons = () => {
    addEventDelegate({
      selector: this.selectors.wishlistButton,
      handler: (t, s) => {
        t.preventDefault();
        const e = s && s.dataset.productHandle;
        if (e) {
          const t = !s.classList.contains(this.addedClass);
          this.toggleButtonState(s, t);
          this.updateWishlistCount();
          document.querySelectorAll(this.selectors.wishlistButton).forEach(t => {
            if (t && t.dataset.productHandle === e && t !== s) {
              const s = !t.classList.contains(this.addedClass);
              this.toggleButtonState(t, s);
            }
          });
        }
      }
    });
  };

  toggleButtonState = (t, s) => {
    const e = t && t.dataset.productHandle;
    if (t && t.dataset.tippyRole) {
      if (s) {
        this.addToWishlist(e);
        t.classList.add(this.addedClass);
      } else {
        this.removeFromWishlist(e);
        t.classList.remove(this.addedClass);
      }
      const o = t.dataset.revertText;
      t.dataset.revertText = t.dataset.tippyContent;
      t.dataset.tippyContent = o;
      if (t._tippy) {
        t._tippy.setContent(o);
      }
    }
  };

  addEventToRemoveButtons = () => {
    addEventDelegate({
      selector: this.selectors.removeButton,
      handler: (t, s) => {
        t.preventDefault();
        const e = s && s.closest(this.selectors.wrapper);
        if (e) {
          e.remove();
        }
        const o = s && s.dataset.productHandle;
        if (o) {
          this.removeFromWishlist(o);
          this.updateWishlistCount();
          if (!this.products.length) {
            this.showNoProductsMessage();
          }
        }
      }
    });
  };

  addEventToPaginationButtons = () => {
    document.querySelector(this.selectors.paginationPrev).addEventListener("click", () => {
      if (this.currentPage > 1) {
        this.currentPage--;
        this.renderWishlistPage();
      }
    });

    document.querySelector(this.selectors.paginationNext).addEventListener("click", () => {
      const totalPages = Math.ceil(this.products.length / this.productsPerPage);
      if (this.currentPage < totalPages) {
        this.currentPage++;
        this.renderWishlistPage();
      }
    });

    document.querySelector(this.selectors.paginationNumbers).addEventListener("click", (e) => {
      if (e.target.classList.contains("m-pagination-number")) {
        this.currentPage = parseInt(e.target.dataset.page);
        this.renderWishlistPage();
      }
    });
  };

  wishlistRemoveButton(t) {
    const s = document.createElement("DIV");
    s.classList.add("m-tooltip", "m-button--icon", "m-wishlist-remove-button", "m-wishlist-remove-button--mobile");
    s.setAttribute("data-product-handle", t);
    s.innerHTML = '<svg class="m-svg-icon--medium" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path></svg>';
    return s;
  }

  renderPagination = (totalPages) => {
    const paginationNumbers = document.querySelector(this.selectors.paginationNumbers);
    const pagination = document.querySelector(this.selectors.pagination);
    paginationNumbers.innerHTML = "";

    if (totalPages <= 1) {
      paginationNumbers.classList.add("m:hidden");
      pagination.style.display = 'none';
      return;
    }

    paginationNumbers.classList.remove("m:hidden");
    pagination.style.display = 'flex';

    for (let i = 1; i <= totalPages; i++) {
      if (i <= 3 || i === totalPages) {
        const pageButton = document.createElement("span");
        pageButton.classList.add("m-pagination-number");
        if (i === this.currentPage) {
          pageButton.classList.add("current");
        }
        pageButton.textContent = i;
        pageButton.dataset.page = i;
        paginationNumbers.appendChild(pageButton);
      } 
    }
  };

  renderWishlistPage = async () => {
    const t = document.querySelector(this.selectors.content),
      s = document.querySelector(this.selectors.container),
      pagination = document.querySelector(this.selectors.pagination),
      paginationPrev = document.querySelector(this.selectors.paginationPrev),
      paginationNext = document.querySelector(this.selectors.paginationNext);

    if (s) {
      s.innerHTML = "";
      let e = true;
      if (this.products.length) {
        const start = (this.currentPage - 1) * this.productsPerPage;
        const end = start + this.productsPerPage;
        const paginatedProducts = this.products.slice(start, end);

        const t = paginatedProducts.map(async (t) => {
          const s = formatUrl("products", t, "view=grid-card-item"),
            o = await fetchCache(s),
            i = document.createElement("DIV");
          i.classList.add("m:hidden", "m:column", "m-wishlist-card");
          i.innerHTML = o;
          i.querySelector(this.selectors.productCard) && ((e = false), i.appendChild(this.wishlistRemoveButton(t)), this.productNodes[t] = i);
        });
        await Promise.all(t);
        paginatedProducts.forEach((t) => {
          const o = this.productNodes[t],
            i = o.querySelector(".m-product-card"),
            a = "true" === document.querySelector(this.selectors.content).dataset.pcardBordered ? "add" : "remove";
          if (o) {
            s.appendChild(o);
            MinimogTheme.CompareProduct && MinimogTheme.CompareProduct.setCompareButtonsState();
            i.classList.contains("m-product-card--bordered") || i.classList[a]("m-product-card--bordered");
            o.classList.remove("m:hidden");
          }
        });

        const totalPages = Math.ceil(this.products.length / this.productsPerPage);
        this.renderPagination(totalPages);

        (this.currentPage === 1) ? paginationPrev.setAttribute('disabled', '') : paginationPrev.removeAttribute('disabled');
        (this.currentPage === totalPages) ?  paginationNext.setAttribute('disabled', '') : paginationNext.removeAttribute('disabled');
        pagination.classList.remove("m:hidden");
      }

      if (e) {
        this.showNoProductsMessage();
      } else {
        this.setWishlistButtonsState();
        MinimogLibs.Tooltip("[data-tippy-content]", {
          animation: "shift-toward",
          touch: false,
          hideOnClick: false,
          onCreate(t) {
            const s = t.reference.dataset.tippyTheme || "m-color-background-1";
            t.setProps({ theme: s });
          },
        });
      }
      t.classList.add("is-visible");
    }
  };

  showNoProductsMessage = () => {
    const t = document.querySelector(this.selectors.content),
      s = document.querySelector(this.selectors.noProducts),
      pagination = document.querySelector(this.selectors.pagination);
    t.classList.add("m:hidden");
    s.classList.remove("m:hidden");
    pagination.classList.add("m:hidden");
  };
}

MinimogTheme.Wishlist = new Wishlist();